<tt-page class="col-xs-12 col-md-4 sp-0" *ngIf="!!menu && !!setting">
    <tt-card>
        <tt-input ttLabel="equipment_name" [ttModel]="menu.equipment_name" ttReadonly></tt-input>

        <tt-tabs [(ttSelectedId)]="selectedBgOeeStateLogHistory" (ttSelectedIdChange)="onTabHistoryChanged()">
            <tt-tab ttId="A" ttLabel="oee_active"></tt-tab>
            <tt-tab ttId="H" ttLabel="oee_history"></tt-tab>
        </tt-tabs>

        <tt-tabs [hidden]="selectedBgOeeStateLogHistory !== 'H'" [(ttSelectedId)]="selectedBgOeeStateLogApprove" (ttSelectedIdChange)="onTabApproveChanged()">
            <tt-tab ttId="not_confirmed" ttLabel="oee_not_approved"></tt-tab>
            <tt-tab ttId="confirmed" ttLabel="oee_approved"></tt-tab>
            <tt-tab ttId="all" ttLabel="all"></tt-tab>
        </tt-tabs>
    </tt-card>

    <tt-list [ttData]="itemsListStateLog"></tt-list>

    <tt-card *ngIf="setting.show_approve_all_button === '1'" [hidden]="selectedBgOeeStateLogHistory !== 'H' && selectedBgOeeStateLogApprove !== 'not_confirmed'">
        <tt-button-save ttText="approve_all" (ttClick)="approveChanges()" [ttLoading]="approving"></tt-button-save>
    </tt-card>
</tt-page>
